module.exports = __webpack_public_path__ + "img/novia.74ae2ea5.jpg";